import React from 'react';
import './Loader.css';

/**
 * Reusable loader for the app.
 * @param {string} [message] - Optional text below the spinner (e.g. "Loading products...")
 * @param {string} [variant] - 'block' (default, content area), 'inline' (small, e.g. in buttons), 'page' (centered full area)
 */
const Loader = ({ message = 'Loading...', variant = 'block' }) => (
  <div className={`loader loader-${variant}`} role="status" aria-live="polite">
    <div className="loader-spinner" aria-hidden />
    {message && <span className="loader-message">{message}</span>}
  </div>
);

export default Loader;
